import { EthAddress } from '@xylabs/sdk-js'
import { TypedEvent, XyoWorldGeotokens, XyoWorldGeotokensEvents } from '@xyo-network/world-typechain'

import { XyoWorldBase } from '../../../Base'
import { BaseJsonObject } from '../../../models'
import { Quadkey } from '../../../Quadkey'
import { EventsV3 } from './v3'

export * from './helpers'

export interface GeotokensEventsJsonObject extends BaseJsonObject {
  blockNumber?: number
  events?: TypedEvent[]
}

class Events extends XyoWorldBase<GeotokensEventsJsonObject> {
  public bidder?: EthAddress

  public contract: XyoWorldGeotokens

  public quadkey?: Quadkey

  public v3: EventsV3

  private _blockNumber?: number

  private _events?: TypedEvent[]

  private onNewEvent?: (event: TypedEvent) => void

  constructor(contract: XyoWorldGeotokens, filter?: { bidder?: EthAddress; quadkey?: Quadkey }, jsonObject?: GeotokensEventsJsonObject) {
    super()
    this.quadkey = filter?.quadkey
    this.bidder = filter?.bidder
    this.contract = contract
    this.v3 = new EventsV3(contract, filter)
    this.loadJsonObject(jsonObject)
  }

  public async all(fromBlockOrBlockHash?: number | string, toBlock?: number) {
    const promises: Promise<TypedEvent[]>[] = []
    promises.push(this.v3.all(fromBlockOrBlockHash, toBlock))
    this._events = (await Promise.all(promises)).flat()
    return this._events
  }

  public async approval(fromBlockOrBlockHash?: number | string, toBlock?: number) {
    const promises: Promise<XyoWorldGeotokensEvents.Approval[]>[] = []
    promises.push(this.v3.approval(fromBlockOrBlockHash, toBlock))
    return (await Promise.all(promises)).flat()
  }

  public load(events: TypedEvent[], blockNumber?: number) {
    this._events = events
    this._blockNumber = blockNumber
  }

  public loadJsonObject(jsonObject?: GeotokensEventsJsonObject) {
    if (jsonObject) {
      this._events = jsonObject.events
      this._blockNumber = jsonObject.blockNumber
    }
    return this
  }

  public monitorEvents(onNewEvent?: (event: TypedEvent) => void) {
    this.onNewEvent = onNewEvent
    /* this.minters.current.contract.addListener('*', (event: Event) => {
      const minterEvent = parseEvent(event, 3)
      this.onNewEvent?.(minterEvent)
    }) */
  }

  public toJsonObject(): GeotokensEventsJsonObject {
    return {
      blockNumber: this._blockNumber,
      events: this._events,
    }
  }
}

export { Events }
